import { createSlice } from "@reduxjs/toolkit";
import { Tab5Input } from "../../model/calculations/calculation";
import { transformObjectToDropdownOptions } from "../../../utilities/commonUtilities";

interface othersState {
    loading: boolean;
    error: string | undefined;
    tab5Input: Tab5Input | null;
    //power conditions
    supplyPowerValue: string;
    supplyPowerListValue: [];
    supplyVoltageValue: string;
    availableKVAValue: string | number;
    controllerValue: string;
    controllerListValue: [];

    //Gas impurities
    oxygenValue: string | number;
    nitrogenValue: string | number;
    h2sValue: string | number;
    co2Value: string | number;

    //Problem Concerns
    corrosionValue: string;
    paraffinValue: string;
    scaleValue: string;
    sandSolidsValue: string;
    viscocityEmulsionValue: string;

    //Other
    packerValue: string;
    chemicalValue: string;
    yToolValue: string;
    scdaCompatibilityValue: string;
    pressureSensorValue: string;

    //notes
    notesValue: string;

}

export const initialState: othersState = {
    loading: false,
    error: "",
    tab5Input: null,
    // Power conditions
    supplyPowerValue: "",
    supplyPowerListValue: [],
    supplyVoltageValue: "",
    availableKVAValue: "",
    controllerValue: "",

    controllerListValue: [],
    // Gas impurities
    oxygenValue: "",
    nitrogenValue: "",
    h2sValue: "",
    co2Value: "",

    // Problem Concerns
    corrosionValue: "",
    paraffinValue: "",
    scaleValue: "",
    sandSolidsValue: "",
    viscocityEmulsionValue: "",

    // Other
    packerValue: "",
    chemicalValue: "",
    yToolValue: "",
    scdaCompatibilityValue: "",
    pressureSensorValue: "",

    // Notes
    notesValue: "",

};

const OthersSlice = createSlice({
    name: "others",
    initialState,
    reducers: {
        resetOthersTab: () => ({
            ...initialState
        }),
        setOtherDetails: (state, action) => {
            state.tab5Input = action?.payload;
        },
        setSupplyPower(state, action) {
            if (state.tab5Input) {
                state.tab5Input = {
                    ...state.tab5Input,
                    unitSuplPwrListVal: action.payload
                };
            }
            state.supplyPowerValue = action.payload;
        },
        setSupplyVoltage(state, action) {
            if (state.tab5Input) {
                state.tab5Input = {
                    ...state.tab5Input,
                    suplVlt: action.payload
                };
            }
            state.supplyVoltageValue = action.payload;
        },
        setAvailableKVA(state, action) {
            if (state.tab5Input) {
                state.tab5Input = {
                    ...state.tab5Input,
                    availKVA: action.payload
                };
            }
            state.availableKVAValue = action.payload;
        },
        setSupplyPowerList(state, action) {
            if (state.tab5Input) {
                state.tab5Input = {
                    ...state.tab5Input,
                    unitSuplPwrList: Object?.keys(action?.payload)?.length > 0 ? transformObjectToDropdownOptions(action?.payload) : []
                }
            }
            state.supplyPowerListValue = action.payload;
        },
        setControllerList(state, action) {
            if (state.tab5Input) {
                state.tab5Input = {
                    ...state.tab5Input,
                    unitContrlList: Object?.keys(action?.payload)?.length > 0 ? transformObjectToDropdownOptions(action?.payload) : []
                }
            }
            state.controllerListValue = action.payload;
        },
        setController(state, action) {
            if (state.tab5Input) {
                state.tab5Input = {
                    ...state.tab5Input,
                    unitContrlListVal: action.payload
                };
            }
            state.controllerValue = action.payload;
        },

        setOxygen(state, action) {
            if (state.tab5Input) {
                state.tab5Input = {
                    ...state.tab5Input,
                    oxygenVal: action.payload
                };
            }
            state.oxygenValue = action.payload;
        },
        setNitrogen(state, action) {
            if (state.tab5Input) {
                state.tab5Input = {
                    ...state.tab5Input,
                    nitrogenVal: action.payload
                };
            }
            state.nitrogenValue = action.payload;
        },
        setH2S(state, action) {
            if (state.tab5Input) {
                state.tab5Input = {
                    ...state.tab5Input,
                    h2S: action.payload
                };
            }
            state.h2sValue = action.payload;
        },
        setCO2(state, action) {
            if (state.tab5Input) {
                state.tab5Input = {
                    ...state.tab5Input,
                    cO2: action.payload
                };
            }
            state.co2Value = action.payload;
        },
        setCorrosion(state, action) {
            if (state.tab5Input) {
                state.tab5Input = {
                    ...state.tab5Input,
                    unitCorsnListVal: action.payload
                };
            }
            state.corrosionValue = action.payload;
        },
        setParaffin(state, action) {
            if (state.tab5Input) {
                state.tab5Input = {
                    ...state.tab5Input,
                    paraffin: action.payload
                };
            }
            state.paraffinValue = action.payload;
        },
        setScale(state, action) {
            if (state.tab5Input) {
                state.tab5Input = {
                    ...state.tab5Input,
                    scale: action?.payload
                };
            }
            state.scaleValue = action.payload;
        },
        setSandSolids(state, action) {
            if (state.tab5Input) {
                state.tab5Input = {
                    ...state.tab5Input,
                    sandSolids: action.payload
                };
            }
            state.sandSolidsValue = action.payload;
        },
        setViscosityEmulsion(state, action) {
            if (state.tab5Input) {
                state.tab5Input = {
                    ...state.tab5Input,
                    viscostyEmulsn: action.payload
                };
            }
            state.viscocityEmulsionValue = action.payload;
        },
        setPacker(state, action) {
            if (state.tab5Input) {
                state.tab5Input = {
                    ...state.tab5Input,
                    packerReqd: action.payload
                };
            }
            state.packerValue = action.payload;
        },
        setChemical(state, action) {
            if (state.tab5Input) {
                state.tab5Input = {
                    ...state.tab5Input,
                    chemicalYN: action.payload
                };
            }
            state.chemicalValue = action.payload;
        },
        setYTool(state, action) {
            if (state.tab5Input) {
                state.tab5Input = {
                    ...state.tab5Input,
                    yToolYN: action.payload
                };
            }
            state.yToolValue = action.payload;
        },
        setScdaCompatibility(state, action) {
            if (state.tab5Input) {
                state.tab5Input = {
                    ...state.tab5Input,
                    scadayn: action.payload
                };
            }
            state.scdaCompatibilityValue = action.payload;
        },
        setPressureSensor(state, action) {
            if (state.tab5Input) {
                state.tab5Input = {
                    ...state.tab5Input,
                    pressureSensYN: action.payload
                };
            }
            state.pressureSensorValue = action.payload;
        },
        setNotes(state, action) {
            if (state.tab5Input) {
                state.tab5Input = {
                    ...state.tab5Input,
                    additnalNotes: action.payload
                };
            }
            state.notesValue = action.payload;
        }
    },
});

export const {
    resetOthersTab,
    setOtherDetails,
    setSupplyPower,
    setSupplyPowerList,
    setControllerList,
    setSupplyVoltage,
    setAvailableKVA,
    setController,
    setOxygen,
    setNitrogen,
    setH2S,
    setCO2,
    setCorrosion,
    setParaffin,
    setScale,
    setSandSolids,
    setViscosityEmulsion,
    setPacker,
    setChemical,
    setYTool,
    setScdaCompatibility,
    setPressureSensor,
    setNotes,
} = OthersSlice.actions;

export default OthersSlice.reducer;
